
      import Application from './app/app';
      import environment from './app/config/environment';

      // Clear prerendered content before Ember renders to prevent duplication
      // The prerendered HTML has content where {{content-for "body"}} was
      // When Ember hydrates, it needs to replace this content, not append to it
      // Check if body has prerendered content (has navbar-container but no {{content-for}})
      const bodyContent = document.body.innerHTML;
      const hasPrerenderedContent = bodyContent.includes('navbar-container') &&
                                     bodyContent.includes('language-loading-overlay') &&
                                     !bodyContent.includes('{{content-for');

      if (hasPrerenderedContent) {
        // Clear the prerendered content so Ember can render fresh
        // This prevents duplication when Ember hydrates
        document.body.innerHTML = '';
      }

      Application.create(environment.APP);
    